// GENERADO — no editar a mano. Origen: backend/src/oficina/compartido/.
// Regenerar: node scripts/gen-oficina-compartido.mjs

// Mesas de una sala (09-10, Pau: «poder arrastrar a los agentes y añadir o quitar mesas como yo quiera, aparte de
// lo automático»). Código PURO y sin imports: lo usan el servidor (validar mover/poner/quitar) y la web (dibujar),
// así los dos cuentan las mismas mesas. Se copia a la web con scripts/gen-oficina-compartido.mjs.
//
// Una sala tiene `total` puestos numerados 0..total-1, en islas de 4. Dos modos:
//   · Automático (`fijadas` null, lo de siempre): la gente + al menos 2 libres, en islas de 4 o media isla final.
//   · A mano (`fijadas` = número): las que Pau dejó. Si contratar llena la sala, crece sola (la mesa nueva es la
//     siguiente a la última ocupada); al irse ese agente, vuelve a las de Pau.
// `huecos` = puestos quitados en medio (sin mesa ni silla): quitar una mesa nunca mueve a nadie de sitio.

export const MAX_PUESTOS_SALA = 24;
/** Hasta dónde se puede contratar y poner mesas a mano: 24 en la principal, 12 en las demás (lo de siempre al contratar). */
export const topeMesas = (principal: boolean): number => (principal ? MAX_PUESTOS_SALA : 12);

export interface MesasSala {
  principal: boolean;
  /** null = automático. */
  fijadas: number | null;
  huecos: readonly number[];
}

/** Cuántos puestos pinta la sala (mesas + huecos), dadas las mesas ocupadas. */
export function totalPuestos(ocupadas: readonly number[], s: MesasSala): number {
  const mayor = ocupadas.reduce((m, x) => Math.max(m, x), -1);
  if (s.fijadas === null) {
    // Lo de siempre (S13): islas de 4 y, si sobran 1-2 puestos, media isla al final.
    const puestos = Math.min(MAX_PUESTOS_SALA, Math.max(ocupadas.length + 2, mayor + 2, s.principal ? 6 : 2));
    const islas = Math.ceil(puestos / 4);
    const resto = puestos % 4;
    return islas * 4 - (resto === 1 || resto === 2 ? 2 : 0);
  }
  return Math.min(MAX_PUESTOS_SALA, Math.max(1, s.fijadas, mayor + 1));
}

/** Los huecos que cuentan: dentro de la sala y sin nadie sentado (si alguien acabó ahí, manda la persona). */
export function huecosVigentes(ocupadas: readonly number[], s: MesasSala, total = totalPuestos(ocupadas, s)): Set<number> {
  const ocupada = new Set(ocupadas);
  return new Set(s.huecos.filter((h) => Number.isInteger(h) && h >= 0 && h < total && !ocupada.has(h)));
}

/** Primera mesa libre (sin nadie y que no sea hueco), por debajo de `max`; undefined si no hay. */
export function primeraMesaLibre(ocupadas: readonly number[], huecos: readonly number[], max: number): number | undefined {
  const ocupada = new Set(ocupadas);
  const hueco = new Set(huecos);
  for (let m = 0; m < max; m += 1) if (!ocupada.has(m) && !hueco.has(m)) return m;
  return undefined;
}
